var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { staticClass: "strat-editor" }, [
    _c("div", { staticClass: "title" }, [
      _c("span", [
        _vm._v("Editar "),
        _c("span", { staticStyle: { color: "#b5e546" } }, [
          _vm._v("Estratégia(s)")
        ])
      ])
    ]),
    _c("div", { staticClass: "bnts-tipo-ativo" }),
    _c(
      "div",
      {
        staticClass: "btn-close",
        on: {
          click: function($event) {
            return _vm.$emit("closeModal")
          }
        }
      },
      [
        _c("v-img", {
          attrs: { src: require("@/assets/icons/clear_icon.svg") }
        })
      ],
      1
    ),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex justify-center align-center pa-8" },
          [
            _c("v-progress-circular", {
              attrs: { size: 35, color: "primary", indeterminate: "" }
            })
          ],
          1
        )
      : _vm._e(),
    _c("div", [_vm._v(" ")]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Tipo:")]),
      _c(
        "div",
        [
          _c("v-select", {
            staticClass: "select-tipo",
            attrs: {
              items: _vm.filterTipos,
              placeholder: "Tipo de ativo",
              color: "secondary",
              "item-text": "name",
              "return-object": "",
              required: "",
              dense: "",
              outlined: "",
              rounded: "",
              disabled: _vm.loading
            },
            on: {
              change: function($event) {
                return _vm.$emit("onChange", $event)
              }
            },
            model: {
              value: _vm.tipoSel,
              callback: function($$v) {
                _vm.tipoSel = $$v
              },
              expression: "tipoSel"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Ativo:")]),
      _c(
        "div",
        [
          _c("v-select", {
            staticClass: "select-ativo",
            attrs: {
              items: _vm.ativos,
              placeholder: "Ativo",
              color: "secondary",
              "item-text": "code",
              "return-object": "",
              required: "",
              dense: "",
              outlined: "",
              rounded: "",
              disabled: _vm.notdefined
            },
            model: {
              value: _vm.ativoSel,
              callback: function($$v) {
                _vm.ativoSel = $$v
              },
              expression: "ativoSel"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Estratégia corrente:")]),
      _c("div", { staticClass: "display" }, [
        _vm._v(" " + _vm._s(_vm.itemStrat))
      ]),
      _c("div", { staticClass: "label" }, [_vm._v("Nova estratégia:")]),
      _c(
        "div",
        [
          _c("v-select", {
            staticClass: "select-ativo",
            attrs: {
              items: _vm.filterStrats,
              placeholder: "Estratégia",
              color: "secondary",
              "item-text": "descricao",
              "return-object": "",
              required: "",
              dense: "",
              outlined: "",
              rounded: "",
              disabled: _vm.notprepared
            },
            model: {
              value: _vm.stratSel,
              callback: function($$v) {
                _vm.stratSel = $$v
              },
              expression: "stratSel"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "conteudo" }, [
      _c("div", { class: _vm.cmdcls }, [
        _c("span", { on: { click: _vm.commitChanges } }, [_vm._v("Editar")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }